<small class="form-text text-muted" *ngIf="state === LoadState.calculating">
  Calculating...
</small>

<small class="form-text text-muted" *ngIf="state === LoadState.failed">
  Could not calculate the first bill.
</small>

<ng-container *ngIf="(state === LoadState.loaded) && result.prorates">

  <small class="form-text text-muted" *ngIf="!startDate">
    This membership bills on the {{ ordinalSuffixedDay(result.bill_day_of_month) }} of the month,
    so the first bill will be pro-rated from
    <ng-container *ngIf="result.allow_selecting_start_date">the start date the customer chooses at checkout.</ng-container>
    <ng-container *ngIf="!result.allow_selecting_start_date">the purchase date.</ng-container>
  </small>

  <div class="alert alert-info mt-2 mb-0" role="alert" *ngIf="startDate && result.is_prorated">
    <b>First bill is pro-rated.</b>
    It covers {{ dateStringFromISO8601(result.period_start_date) }} through {{ dateStringFromISO8601(periodEndDayBefore()) }},
    {{ result.prorated_days }} of {{ result.total_days }} days ({{ result.percentage }}%) of the
    {{ intervalDisplayLower() }} period, which bills on the {{ ordinalSuffixedDay(result.bill_day_of_month) }}.
    Base fee {{ currencySymbol() }}{{ result.base_fee }} {{ intervalDisplayLower() }};
    first bill {{ currencySymbol() }}{{ result.prorated_base_fee }} at the base fee.
    Regular billing begins {{ dateStringFromISO8601(result.period_end_date) }}.
    <small class="d-block mt-1">
      Base fee only. Does not include tax, the initiation fee, discounts, add-ons or upfront payment options.
    </small>
  </div>

  <div class="alert alert-info mt-2 mb-0" role="alert" *ngIf="startDate && (result.is_prorated === false)">
    The start date is the billing day, so the first bill is a full {{ intervalDisplayLower() }} period at
    the base fee, {{ currencySymbol() }}{{ result.base_fee }}.
    <small class="d-block mt-1">
      Base fee only. Does not include tax, the initiation fee, discounts, add-ons or upfront payment options.
    </small>
  </div>

</ng-container>
